import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from '../../../../../shared/helpers/utils';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  allocationBox: (props) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor:
      props.remainingAllocation === 0 &&
      !!props.selectedTotal &&
      props.selectedTotal !== '0'
        ? '#EFFBF0'
        : '#FFCCCC',
    padding: '30px',
    borderRadius: '6px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '18px',
    },
  }),
  allocationText: (props) => ({
    padding: '4px 8px',
    borderRadius: '10px',
    minWidth: '117px',
    textAlign: 'center',
    color: 'white !important',
    wordBreak: 'break-all',
    marginLeft: '16px !important',
    backgroundColor:
      props.remainingAllocation <= 0 &&
      !!props.selectedTotal &&
      props.selectedTotal !== '0'
        ? '#D9D9D9'
        : theme.palette.secondary.main,
  }),
}));

export const RemainingAllocationLabelTypography = styled(Typography)(
  ({ theme }) => ({
    fontSize: 24,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      fontWeight: 600,
    },
  })
);

export const RemainingAllocationTypography = styled(Typography)(
  ({ theme }) => ({
    fontSize: 20,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  })
);

const RemainingAllocationDisplay = ({ remainingAllocation, selectedTotal }) => {
  const formattedAllocation = formatCurrency(
    remainingAllocation < 0 ? 0 : remainingAllocation
  );
  const isLongText = formattedAllocation.length > 8; // Consider text long if it's more than 8 characters
  const classes = useStyles({ remainingAllocation, selectedTotal, isLongText });

  return (
    <Box className={classes.allocationBox}>
      <RemainingAllocationLabelTypography>
        Remaining Allocation:
      </RemainingAllocationLabelTypography>
      <RemainingAllocationTypography className={classes.allocationText}>
        {formattedAllocation}
      </RemainingAllocationTypography>
    </Box>
  );
};

RemainingAllocationDisplay.propTypes = {
  remainingAllocation: PropTypes.number.isRequired,
  selectedTotal: PropTypes.number.isRequired,
};

export default RemainingAllocationDisplay;
